import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#0f0d31',
      text: '#FFFFFF',
    },
    secondary: {
      main: '#E06655',
      text: '#FFFFFF',
    },
    tertiary: {
      main: '#DEDFE0',
      text: '#E06655',
    },
    darkGreen: '#1D2623',
    bg: '#F2E8E2',
    pink: '#e6a',
    magenta: '#b3f',
    purple: '#339',
    cyan: '#4df',
    red: '#903',
    blue: '#137',
  },
  typography: {
    fontFamily: 'Poppins',
    headerLink: {
      fontFamily: 'Poppins',
      fontSize: '1.25rem',
      margin: '10px 0 10px 0',
    },
    body1: {
      margin: '10px 0 10px 0',
      fontSize: '1.125rem',
    },
    reportSectionAnalysis: {
      margin: '15px 10px 15px 10px',
      textAlign: 'left',
      display: 'block',
      fontSize: '1.125em',
    },
    questionsLabel: {
      fontFamily: 'Poppins',
      fontSize: '1.125em',
    },
  },
  shape: {
    borderRadius: 0,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 0,
        },
      },
    },
  },
});

export default theme;
